module.exports = __webpack_public_path__ + "static/media/build.5b0ca5fd.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/build.svg
// module id = 464
// module chunks = 0